import React, { FC } from 'react';
import styles from './SignUp.module.scss';
import male from 'images/new-icons/men-icon.png';
import female from 'images/new-icons/women-icon.png';
import Button from 'components/shared/Button';
import useUpdateGender from 'sdk/hooks/user/useUpdateGender';
import useUser from 'sdk/hooks/user/useUser';
import { useTranslation } from 'react-i18next';

type Props = {
  className?: string;
  handleNext: () => void;
};

const GenderView: FC<Props> = ({ className, handleNext }) => {
  const { t } = useTranslation() as any;
  const { mutate: updateGender, isLoading, isError, isSuccess } = useUpdateGender();
  const userData = useUser();
  const userId = userData?.data?.user?.id || '';

  const handleGenderSelect = (gender: number) => {
    updateGender(
      { userId, gender },
      {
        onError: error => {
          console.error('Failed to update gender:', error);
        },
        onSuccess: () => {
          handleNext();
        },
      },
    );
  };

  return (
    <div className={className}>
      <div className={styles.header}>{t('select_who_you_are')}</div>
      <div className={styles.gender}>
        <div>
          <img className={styles.gender_image} src={male} alt="" />
          <Button loading={isLoading} onClick={() => handleGenderSelect(1)} darkGreen wide>
            {t('for_him')}
          </Button>
        </div>
        <div>
          <img className={styles.gender_image} src={female} alt="" />
          <Button loading={isLoading} onClick={() => handleGenderSelect(2)} darkGreen wide>
            {t('for_her')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GenderView;

